import React, { useState, useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import '../App.css';
import MyStorage from './util/storage';
import Api from './api/api'

const MySidebar = ({ }) => {
    const [activeIndex, setActiveIndex] = useState(100);

    const logoutUser = () => {
        console.log('logoutUser');
        // let user = MyStorage.getUser()
        MyStorage.setUser(null)
        // Api.logoutUser(user.id,
        //     (response) => {
        //         //
        //     },
        //     (error) => {
        //         //
        //     });
    };

    // check session
    if (!MyStorage.isLogin()) {
        return <Navigate to='/admin/login' replace />;
    }

    return (
        <div>
            <div style={{ height: '90vh', width: 200, display: 'flex', flexDirection: 'column', backgroundColor: 'black', paddingTop: 5 }}>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/analytics',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(8080)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 8080 ? 'gray' : 'black' }}>
                        Analytics
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/app-version',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(8081)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 8081 ? 'gray' : 'black' }}>
                        App Version
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/products',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(100)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 100 ? 'gray' : 'black' }}>
                        Products
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/affiliates',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(1001)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 1001 ? 'gray' : 'black' }}>
                        Affiliate Products
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/contact',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(101)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 101 ? 'gray' : 'black' }}>
                        Contact Info
                    </div>
                </Link>

                {/* <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/doctors',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(1)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 1 ? 'gray' : 'black' }}>
                        Doctors
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/patients',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(11)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 11 ? 'gray' : 'black' }}>
                        Patients
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/withdrawals',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(2)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 2 ? 'gray' : 'black' }}>
                        Withdrawal Requests
                    </div>
                </Link> */}

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/recipes',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(321)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 321 ? 'gray' : 'black' }}>
                        Recipes
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/videos',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(30)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 30 ? 'gray' : 'black' }}>
                        Videos
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/mind-articles',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(4342)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 4342 ? 'gray' : 'black' }}>
                        Mind Articles
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/medical-tidbits',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(5050)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 5050 ? 'gray' : 'black' }}>
                        Medical Tidbits
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/quizzes',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(7070)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 7070 ? 'gray' : 'black' }}>
                        Quizzes
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/articles',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(3)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 3 ? 'gray' : 'black' }}>
                        Education
                    </div>
                </Link>

                

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/send-notification',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(6060)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 6060 ? 'gray' : 'black' }}>
                        Send Notification
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/scheduled-notifications',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(6061)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 6061 ? 'gray' : 'black' }}>
                        Scheduled Notifications
                    </div>
                </Link>

                <div
                    onClick={() => {
                        logoutUser()
                        setActiveIndex(4)
                    }}
                    className='menu-item'
                    style={{ backgroundColor: activeIndex === 4 ? 'gray' : 'black', display: 'flex', alignItems: 'center' }}>
                    Logout
                </div>

            </div>
        </div>
    );
}

export default MySidebar;
